import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../FirebaseConfig";
import { toastOptions } from "../../lib/toastOptions";
import { toast } from "react-toastify";
import { UserAuth } from "../../Context";
import LoadingSpinner from "../LoadingSpinner";

function CategoriesSelection() {
  const { user } = UserAuth();
  const [gender, setGender] = useState("male");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [primaryCategories, setPrimaryCategories] = useState({});
  const [visibleCategories, setVisibleCategories] = useState({
    "Ready to Wear": true,
    "Western Wear": true,
    Unstitched: true,
  });
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Fetch categories
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const categoriesCol = collection(db, "universalCategories");
      const categoriesSnapshot = await getDocs(categoriesCol);
      let genderArray = [];

      categoriesSnapshot.docs.forEach((doc) => {
        let GenderData = doc.data();
        genderArray.push(GenderData);
      });

      let maleCategories = genderArray[0];
      let femaleCategories = genderArray[1];

      if (gender === "male") {
        setPrimaryCategories(maleCategories);
      } else if (gender === "female") {
        setPrimaryCategories(femaleCategories);
      }
    } catch (error) {
      console.error("Error fetching brand display names:", error);
      toast.error("Error fetching brand display names", toastOptions);
    } finally {
      setLoading(false);
    }
  };

  // Save categories to Firebase
  const saveCategories = async (updatedCategories) => {
    try {
      const userDocRef = doc(db, "users", user.uid);
      await updateDoc(userDocRef, {
        favCategories: updatedCategories,
      });
    } catch (error) {
      console.error(error);
      toast.error("Error updating categories", toastOptions);
    }
  };

  // Handle category click
  const handleCategoryClick = async (item) => {
    const select = {
      category: item.category || "",
      subCategory: item.subCategory || "",
      subSubCategory: item.subSubCategory,
      subSubCategoryDisplayName: item.subSubCategoryDisplayName,
    };

    const isAlreadyAdded = categories?.some(
      (existing) =>
        existing.category === select.category &&
        existing.subCategory === select.subCategory &&
        existing.subSubCategory === select.subSubCategory
    );

    let updatedCategories;

    if (isAlreadyAdded) {
      updatedCategories = categories.filter(
        (existing) =>
          !(
            existing.category === select.category &&
            existing.subCategory === select.subCategory &&
            existing.subSubCategory === select.subSubCategory
          )
      );
    } else {
      updatedCategories = [...(categories || []), select];
    }

    setCategories(updatedCategories);
    await saveCategories(updatedCategories);
  };

  const toggleCategoryVisibility = (categoryKey) => {
    setVisibleCategories((prevState) => ({
      ...prevState,
      [categoryKey]: !prevState[categoryKey],
    }));
  };

  useEffect(() => {
    if (gender === "") return;
    const fetchData = async () => {
      await fetchCategories();
    };
    fetchData();
    // eslint-disable-next-line
  }, [gender]);

  // Fetch user profile
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (user && user.uid) {
          const userDocRef = doc(db, "users", user.uid);
          const userDocSnapshot = await getDoc(userDocRef);

          if (userDocSnapshot.exists()) {
            const userDataFromDb = userDocSnapshot.data();
            setCategories(userDataFromDb.favCategories || []);
            setGender(userDataFromDb.gender || "male");
          }
        }
      } catch (error) {
        console.error("Error fetching user data from database", error);
      }
    };

    fetchUserData();
  }, [user]);

  return (
    <div>
      {/* <div
        className="d-none d-md-block"
        style={{
          fontFamily: "Inter",
          fontWeight: "600",
          fontSize: "28px",
          color: "#000000",
        }}
      >
        Categories
      </div> */}

      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="d-flex flex-column" style={{ gap: "4px" }}>
          {Object.keys(primaryCategories || {})
            .sort()
            ?.map((categoryKey) => (
              <div
                key={categoryKey}
                className="d-flex flex-column align-items-start"
                style={{ gap: "4px" }}
              >
                <div style={{ padding: isSmallScreen ? "10px" : "10px 0px" }}>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: isSmallScreen ? "16px" : "20px",
                      color: "#000000",
                      cursor: "pointer",
                    }}
                  >
                    {categoryKey}
                  </div>
                </div>
                {visibleCategories[categoryKey] && (
                  <ul
                    className="list-inline mb-0 d-flex flex-wrap"
                    style={{
                      padding: isSmallScreen ? "6px 10px" : "6px 0px",
                      gap: "12px",
                    }}
                  >
                    {primaryCategories[categoryKey].map((item, index) => {
                      const isSelected = categories?.some(
                        (element) =>
                          element.category === item.category &&
                          element.subCategory === item.subCategory &&
                          element.subSubCategory === item.subSubCategory
                      );

                      return (
                        <li
                          key={index}
                          onClick={() => handleCategoryClick(item)}
                        >
                          <div
                            className={`btn btn-sm  position-relative d-flex align-items-center justify-content-center`}
                            style={{
                              borderRadius: "6px",
                              backgroundColor: isSelected
                                ? "#005FDA"
                                : "#F4F9FF",
                              paddingRight: isSelected ? "1.75rem" : "1rem",
                              height: "27px",
                            }}
                          >
                            <div
                              style={{
                                fontFamily: "Inter",
                                fontWeight: "400",
                                fontSize: "14px",
                                color: isSelected ? "white" : "black",
                              }}
                            >
                              {item.subSubCategoryDisplayName}
                            </div>
                            {isSelected && (
                              <div
                                className="position-absolute end-0 top-50 translate-middle-y me-2"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCategoryClick(item);
                                }}
                              >
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.25 5.25L12.75 12.75"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M5.25 12.75L12.75 5.25"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            )}
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default CategoriesSelection;
